import { FormGroup } from '@angular/forms';

import { UtilService } from '../../../../../shared/services/util.service';

/**
 * Contas do item da venda. Os tributos do item NÃO são calculados aqui: ficam com o que foi
 * informado (ou zerados) até a integração com o motor fiscal, que conhece regra tributária,
 * exceção por UF e benefício. Mesmo papel do `nfe-item.calculo.ts` da NF-e de saída.
 */

/** Dinheiro é sempre 2 casas: centavo é a menor parte que existe. */
const CASAS_DINHEIRO = 2;

function numero(grupo: FormGroup, caminho: string): number {
    return Number(grupo.get(caminho)?.value ?? 0) || 0;
}

function gravar(grupo: FormGroup, caminho: string, valor: number): void {
    // emitEvent falso: estes campos são RESULTADO. Emitir reentraria no próprio recálculo.
    grupo.get(caminho)?.setValue(UtilService.arredondarAbnt(valor, CASAS_DINHEIRO), { emitEvent: false });
}

/** Total do item: quantidade × preço unitário negociado. */
export function totalDoItem(quantidade: number, precoLiquidoUnitario: number): number {
    return UtilService.arredondarAbnt((Number(quantidade) || 0) * (Number(precoLiquidoUnitario) || 0), CASAS_DINHEIRO);
}

export function baseDoItem(item: FormGroup): number {
    return totalDoItem(numero(item, 'dados.quantidade'), numero(item, 'dados.precoLiquidoUnitario'));
}

/** Soma de IBS e CBS gravados no item, para a lista (o grupo não grava o total). */
export function totalIbsCbsDoItem(item: FormGroup): number {
    return UtilService.arredondarAbnt(numero(item, 'ibsCbs.valorIbs') + numero(item, 'ibsCbs.valorCbs'), CASAS_DINHEIRO);
}

/** Recalcula os valores derivados do item: o total e a comissão. Só os campos de valor são escritos. */
export function recalcularValoresDoItem(item: FormGroup): void {
    const base = baseDoItem(item);

    item.get('dados.valorTotal')?.setValue(base, { emitEvent: false });

    calcularComissao(item, base);
}

/**
 * Comissão = % × (total do item - parcela rateada do desconto global): a base é o que o cliente
 * paga pelo item, em reais (D21). Mesma conta de `AplicarDescontoGlobalEComissao` da folha e da
 * base exibida na aba Comissão (`baseDaComissao`).
 */
function calcularComissao(item: FormGroup, base: number): void {
    gravar(item, 'comissao.valorComissao', baseDaComissao(item, base) * numero(item, 'comissao.percentualComissao') / 100);
}

/** Base da comissão: o total do item menos a parcela rateada do desconto do documento. */
export function baseDaComissao(item: FormGroup, base: number = baseDoItem(item)): number {
    return UtilService.arredondarAbnt(base - numero(item, 'dados.valorDescontoRateado'), CASAS_DINHEIRO);
}
